<template>
  <div class="row question pl-2" :class="{'has-filter': hasFilter }">
    <div class="col-10">
      <b-button v-if="hasIssues"
                size="sm"
                class="issues-btn"
                variant="outline-secondary"
                @click.prevent="$store.commit('selectQuestion', {question: question})">
        <b-badge :variant="issuesOutstandingCount ? 'danger' : 'secondary'">{{issuesOutstandingCount}}</b-badge>
        &nbsp;&nbsp;
        <FormatListChecksIcon></FormatListChecksIcon>
      </b-button>
      <div class="prompt">
        <a href="" @click.prevent="$store.commit('selectQuestion', {question: question})">{{question.prompt}}</a>      
        <CommentQuestionIcon v-if="hasMoreInfo" class="more-info-btn" @click.prevent="$store.dispatch('fetchMoreInfo', question.moreInfoId)"></CommentQuestionIcon>
      </div>
      <div class="hint" v-if="question.hint">
        {{question.hint}}
      </div>
    </div>
    <div class="col-2" v-if="question.type == QuestionType.YesNo || question.type == QuestionType.YesNoNA">
      <yes-no-input v-model="question.value" :disabled="readonly" :allowNA="question.type == QuestionType.YesNoNA" @input="valueChanged($event)"></yes-no-input>
    </div>
    <div class="col-2" v-else-if="question.type == QuestionType.Textbox">
      <input type="text" class="form-control mb-1" :disabled="readonly" v-model.lazy.trim="question.textValue" @change="textValueChanged($event.target.value)">
    </div>
    <div class="col-2" v-else-if="question.type == QuestionType.LookupList">
      <LookupListInput v-if="question.lookupListId" :lookupListId="question.lookupListId" :disabled="readonly" v-model="question.textValue" @input="textValueChanged($event)"></LookupListInput>
      <span v-else>Invalid Lookup List</span>
    </div>
    <div class="col-2" v-else>
      Invalid Type
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Client, Operation, QuestionDto, QuestionType } from "../code/EngineeringChecklist.Api";
import YesNoInput from './inputs/YesNoInput.vue';
import LookupListInput from './inputs/LookupListInput.vue';
import FormatListChecksIcon from 'vue-material-design-icons/FormatListChecks.vue';
import CommentQuestionIcon from 'vue-material-design-icons/CommentQuestion.vue';

export default Vue.extend({
  name: 'Question',
  components: {
    YesNoInput,
    LookupListInput,
    FormatListChecksIcon,
    CommentQuestionIcon
  },
  props: {
    parent: {type: Object, required: true},
    question: {type: Object, required: true},
    readonly: {type: Boolean, required: true}
  },
  data() {
    return {
      QuestionType,
      patches: []
    }
  },
  computed: {
    hasMoreInfo: function () {
      return this.question && this.question.moreInfoId;
    },
    hasIssues: function() {
      return this.question && this.question.issues && this.question.issues.length;
    },
    issuesOutstanding: function() {
      return _.filter(this.question.issues, {resolved:false}) || this.question.issues;
    },
    issuesOutstandingCountVal: function() {
      return this.issuesOutstanding ? this.issuesOutstanding.length : 0;
    },
    issuesOutstandingCount: function() {
      return this.question ? this.question.issuesOutstandingCount : 0;
    },
    hasFilter: function() {
      return this.question && this.question.conditionsObj && this.question.conditionsObj.children && this.question.conditionsObj.children.length
    },
    conditionsObj: function() {
      return this.question.conditionsObj;
    },
    hierarchyVal: function() {
      if (this.parent) {
        return `${this.parent.hierarchy} > ${this.parent.name}`;
      } else {
        return '';
      }
    }
  },
  methods: {
    valueChanged: function(value) {
      if (value === 0 ) {
        this.$store.commit('selectQuestion', {question: this.question})
      }

      this.patch('replace', '/value', value);
    },
    textValueChanged: function(value) {
      this.patch('replace', '/textValue', value);
    },
    patch: function(op, path, value) {
      if (this.readonly) return;

      let patch = _.find(this.patches, {op: op, path: path });
      
      if (patch) {
        patch.value = value;
      } else {
        patch = new Operation({op: op, path: path, value: value});
        this.patches.push(patch);
      }

    },
    processPatches: function() {

      if (this.patches && this.patches.length) {
        var c = new Client(process.env.VUE_APP_API_URL, this.$http);

        c.questions_Patch(this.question.id, this.patches)
          .then(function(updatedQuestion){
            if (updatedQuestion) {
              delete updatedQuestion.issues;
              Object.assign(this.question, updatedQuestion);
            }

            this.patches = [];
          }.bind(this))
          .catch(function(error){

          })

      }
    },

  },
  watch: {
    hierarchyVal: function(newValue, oldValue) {
      this.question.hierarchy = newValue;
      for (const issue of this.question.issues) {
        this.$set(issue, 'hierarchy', `${newValue} > ${this.question.prompt}`);
      }
    },
    issuesOutstandingCountVal: function(newValue, OldValue)
    {
      this.question.issuesOutstandingCount = newValue;
    },
    patches: function(newValue, oldValue) {
      if (newValue && newValue.length) {
        this.debouncedProcessPatches();
      }
    },
    conditionsObj: {
      deep: true,
      handler: function(newValue, OldValue)
      {
        this.question.conditions = JSON.stringify(newValue)
        this.patch('replace', '/conditions', this.question.conditions);
      }
    }
  },
  created() {

    this.debouncedProcessPatches = _.debounce(this.processPatches, 100, {
      leading: false,
      trailing: true
    });
  }
});
</script>

<style lang="scss" scoped>
  .question {
    .more-info-btn {
      top: 2px;
      color: #007bff;
      height: 20px;
      width: 24px;

      &:hover {
        cursor: pointer;
        color: #0069d9;
      }
    }

    .issues-btn {
      float: right;
      padding: 2px 4px;
    }
    // .issues {
    //   position: relative;
    //   font-size: 1em;
    //   float: right;
    //   padding: 0 1.75em 0 0.25em;
    //   cursor: pointer;
    //   .format-list-checks-icon {
    //     height: 1.25em;
    //     width: 1.25em;
    //     position: absolute;
    //     padding: 0.125em;
    //   }
    //   &:hover {
    //     outline: 1px dashed;
    //     border-radius: 0.25em;
    //   }
    //   &.outstanding-issues {
    //     color: red;
    //     &:hover {
    //       color: white;
    //       background-color: red;
    //     }
    //   }
    // }

    &:hover {
      background-color: #EEE !important;
      // font-weight: bold;
    }
  }
</style>